export default __webpack_public_path__ + "static/DIN-Pro-Black-aea2131e512dc016b370bdcc4f5f8455.woff";